export const DASHBOARD_PATH = '/dashboard/default';
export const DEFAULT_THEME_MODE = 'light';

export const CSS_VAR_PREFIX = '';

const config = {
  fontFamily: `'Poppins', sans-serif`,
  borderRadius: 8,
  mode: DEFAULT_THEME_MODE
};

export default config;
